export default {"src":"/_next/static/media/profile-photo-placeholder-grey.8d72e599.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};